// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDLOgVIaA_NWowZ0TAnZjW9ggv-Kwt4F_c",
  authDomain: "gujju-stream.firebaseapp.com",
  projectId: "gujju-stream",
  storageBucket: "gujju-stream.appspot.com",
  messagingSenderId: "122698920901",
  appId: "1:122698920901:web:3a1103915672585df291ac",
  measurementId: "G-CQM8VJZ01D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth =getAuth(app)